import mainCustReport from './mainCustReport'
export default mainCustReport
